import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import React from 'react';
import clsx from 'clsx';
import capitalize from "../../helpers/capitalize";
import colors from "../../utils/colors";
import { WarningFilled } from "../../icons";

import RadioButton from "../RadioButton/index";
import { createStyles } from "./styles";

var RadioGroup = function RadioGroup(props) {
  var
    value =







    props.value,onChange = props.onChange,radioButtons = props.radioButtons,label = props.label,validationMessage = props.validationMessage,_props$validationPass = props.validationPassed,validationPassed = _props$validationPass === void 0 ? true : _props$validationPass,_props$type = props.type,type = _props$type === void 0 ? 'column' : _props$type,_props$className = props.className,className = _props$className === void 0 ? '' : _props$className;

  var classes = createStyles(props);

  return /*#__PURE__*/(
    React.createElement("div", { className: clsx(classes.wrapper, className) }, /*#__PURE__*/
    React.createElement("p", { className: classes.label }, label), /*#__PURE__*/
    React.createElement("ul", { className: clsx(classes.list, classes["list".concat(capitalize(type))]) },
    _mapInstanceProperty(radioButtons).call(radioButtons, function (radioButton) {
      return /*#__PURE__*/(
        React.createElement(RadioButton, {
          key: radioButton.id,
          id: radioButton.id,
          value: radioButton.value,
          label: radioButton.label,
          checked: value === radioButton.value,
          disabled: radioButton.disabled,
          onChange: onChange }));


    })),

    validationPassed === false && /*#__PURE__*/
    React.createElement("p", { className: classes.validationBlock }, /*#__PURE__*/
    React.createElement(WarningFilled, { color: colors.red[500], width: "1.2rem", height: "1.2rem" }), /*#__PURE__*/
    React.createElement("span", { className: classes.validationMessage }, validationMessage))));




};
RadioGroup.displayName = 'RadioGroup';

export default RadioGroup;
//# sourceMappingURL=index.js.map